//Angular References
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

//Service
import { UtilityService } from '../../../services/shared/utility.service';
import { WizardService } from '../../../services/wizard.service';

//Models
import { WizardResponse, WizardDetails } from '../../../models/wizard.model';
import { environment } from '../../../../environments/environment';


@Component({
    selector: 'app-thankyou',
    templateUrl: './thankyou.component.html',
    styleUrls: ['./thankyou.component.css']
})

export class ThankyouComponent implements OnInit {
    panelTitle: string;
    documentForm: FormGroup;
    private encryptedUser: string = '';
    private wizardResponse: WizardResponse;
    private wizardDetails: WizardDetails;
    inventionId: number;
    productId: number;
    wizardId: number;
    wizard: WizardDetails;
    site: string;
    document: string;
    logoPath: string;
    public appVersion;

    constructor(private fb: FormBuilder,
        private _utilityService: UtilityService,
        private _route: ActivatedRoute,
        private _wizardService: WizardService,
    ) {
        this.appVersion = environment.appVersion;
    }

    ngOnInit() {
        this.documentForm = this.fb.group({});

        this.loadDocument();
    }

    // convenience getter for easy access to form fields
    get form() { return this.documentForm.controls; }

    private async loadDocument() {
        this._route.paramMap.subscribe(async params => {
            if (params.has('invention')) {
                this.inventionId = +params.get('invention');
                this.panelTitle = 'Record of Invention - ' + ' Complete';
            }
            if (params.has('productId')) {
                this.productId = +params.get('productId');
                //this.logoPath = this.productId > 8 ? "assets/images/logo/Patent-Plus.png" : "assets/images/logo/logo_1226.png";
                this.logoPath = "assets/images/logo/logo_1226.png";
            }
            else
                console.log("no invention");
        });
    }
}
